import { ProtectionPlansSelectionType } from '@upstart/harmony/lib/constants';

const DefaultNewBundle = {
  name: '',
  description: '',
  image: null,
  markup: 0,
  discount: 0,
  enabled: false,
  productIds: [],
  selectedInStore: ProtectionPlansSelectionType.None,
  selectedOnline: ProtectionPlansSelectionType.None,
};

export default DefaultNewBundle;
